export const DEFAULT_META = {
  pageTitle: 'Help and Support',
  description: 'belong help and support',
  keywords: 'belong, support, help'
};
